module.exports = __webpack_public_path__ + "images/help/video-todos-3fb070e8cd6fc8e494945598d1c468e6.png";